// src/components/chat/ReplyIndicator.jsx
import React from 'react';
import FileAttachment from '../media/FileAttachment';
import FileViewer from '../media/FileViewer';
import { getFileIcon, truncateFileName  } from '../../utils/fileHelpers';
import { formatFileSize } from '../../utils/formatters';
import './ReplyIndicator.css';

const ReplyIndicator = ({ replyToMessage, onCancel }) => {
   
    if (!replyToMessage) return null;

    return (
        <div className="reply-indicator">
            <div className="reply-content-wrapper">
                <div className="reply-label">
                    <i className="bi bi-reply-fill"></i> Ответ для {replyToMessage.display_name} на:
                        <button  onClick={onCancel}>
                            <i className="bi bi-x"></i>
                        </button>
                </div>


                {/* Текст (если есть) */}
                {replyToMessage.content && 
                 replyToMessage.type !== 'sticker' && 
                 replyToMessage.type !== 'media' && (
                    <div className="reply-text">
                        {replyToMessage.content.substring(0, 100)}
                    </div>
                )}

                {/* Стикер */}
                {replyToMessage.type === 'sticker' && (
                    <div className="reply-text">🎨 Стикер</div>
                )}

                {/* Медиа */}
                {replyToMessage.attachments && replyToMessage.attachments.length > 0 && (
                    <div className="reply-preview">
                        {replyToMessage.attachments.slice(0, 3).map((att, idx) => {
                            if (att.file_type === 'image') {
                                return (
                                    <div key={idx} className="reply-preview-item">
                                        <FileAttachment
                                            mediaUrl={att.media_url}
                                            fileName={att.file_name}
                                            className="reply-preview-image"
                                        />
                                    </div>
                                );
                            } else if (att.file_type === 'video') {
                                return (
                                    <div key={idx} className="reply-preview-item">
                                        <FileViewer
                                            filePath={att.media_url}
                                            fileName={att.file_name}
                                            fileType="video"
                                            className="reply-preview-video"
                                        />
                                    </div>
                                );
                            } else if (att.file_type === 'audio') {
                                return (
                                    <div key={idx} className="reply-preview-icon">
                                        <i className="bi bi-mic-fill"></i>
                                    </div>
                                );
                            } else {
                                const fileIcon = getFileIcon(att.file_name);
                               const fileSize = formatFileSize(att.file_size);
                                const displayName = truncateFileName(att.file_name, 14);
                                return (
                                <div key={idx}  className="reply-file-card">
                                    <div className="reply-file-icon">
                                        <i className={fileIcon}></i>
                                    </div>                                    
                                    <div className="reply-file-name" title={att.file_name}>
                                        {displayName} 
                                        <p>{fileSize}</p>
                                    </div>
                                   
                                </div>
                                    
                                );
                            }
                        })}
                        {replyToMessage.attachments.length > 3 && (
                            <div className="reply-preview-more">
                                +{replyToMessage.attachments.length - 3}
                            </div>
                        )}
                    </div>
                )}            
                 
            </div>     
           
        </div>
    );
};

export default ReplyIndicator;